import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import VueI18n from "vue-i18n"

import { enUS, zhCN } from "./locales/index"
// 插件
import "./plugins/element-ui"
import "./plugins/app-axios"
import "./plugins/clipboard"
import "./plugins/df-ui"
import "./plugins/vue-i18n"

import "idf-ui/dist/idf-ui.css"

const i18n = new VueI18n({
  locale: "zh-CN",
  messages: {
    "zh-CN": zhCN,
    "en-US": enUS,
  },
})

Vue.config.productionTip = false
// 从模版初始化
store.dispatch("setInit")

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
